<template>
  <UModal
    :model-value="modalOpen"
    :ui="{ background: 'bg-transparent', shadow: 'shadow-none' }"
    @update:model-value="handleClose"
  >
    <!-- <component
      :is="modalOptions.component"
      v-if="modalOptions.component"
      v-bind="modalOptions.componentProps"
    /> -->
    <component
      :is="componentLoaded"
      v-bind="modalOptions.componentProps"
      v-if="componentLoaded"
      :is-modal="true"
    />
    <div
      v-else-if="!modalOptions.component"
      class="bg-white"
    >
      <h2>{{ modalOptions.title }}</h2>
      <p>
        {{ modalOptions.description }}
      </p>
      <pre>{{ modalOptions }}</pre>
    </div>
  </UModal>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

const { modalOptions, modalOpen, closeModal } = useGlobalModal()

function handleClose() {
  if (typeof modalOptions.value?.cancel === 'function') {
    modalOptions.value.cancel()
  }
  closeModal()
  componentLoaded.value = null
}
const componentLoaded = shallowRef<Component | null>(null)
const componentMap = {
  reviewCard: defineAsyncComponent(() => import('./Collection/Review/Card.vue')),
  reviewGBFCard: defineAsyncComponent(() => import('./Collection/ReviewGBF/Card.vue')),
}

function loadComponent() {
  const component = modalOptions.value?.component as keyof typeof componentMap | undefined
  componentLoaded.value = component ? componentMap[component] : null
}

watch([modalOpen, () => modalOptions.value.component], loadComponent, { immediate: true })
</script>

<style scoped>

</style>
